import { useMemo } from 'react';
import { formatNumber } from '../../../../utilities/Helpers';

interface CountPercCellProps {
  value: any;
  total: any;
}
const CountPercCell: React.FC<CountPercCellProps> = ({ value, total }) => {
  const perc = useMemo(() => {
    if (!value || !total || isNaN(value) || isNaN(total) || total == 0) {
      return 0;
    }
    return parseFloat(formatNumber((value / total) * 100, 2));
  }, [value, total]);

  return (
    <div>
      {value} ({perc}%)
    </div>
  );
};
export default CountPercCell;
